import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';

const SectionFooter: React.FC<{
  children?: any;
}> = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.sectionFooterRoot}>
      <AppBar id="section-footer" position="static" className={classes.sectionFooterAppBarRoot}>
        {children}
      </AppBar>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  sectionFooterRoot: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    zIndex: 99,
  },
  sectionFooterAppBarRoot: {
    backgroundColor: `white !important`,
  },
}));

export default SectionFooter;
